<script>
import {openDocument} from "@/baseUtils";
import {mapActions} from "pinia";
import {baseLoaderStore} from "@/store/baseLoaderStore";
import BaseAvatar from "@/components/BaseAvatar/BaseAvatar.vue";

export default {
  name: "SourceListItem",
  props: {
    itemData: {
      type: Object
    }
  },
  components: {
    BaseAvatar
  },
  computed: {
    sourceCreator() {
      return this.itemData.source.source.content.creator;
    }
  },
  methods: {
    ...mapActions(baseLoaderStore, [
      'showBaseLoader',
      'hideBaseLoader'
    ]),
    getDocument() {
      const type = this.itemData.source.source.content.type;
      const hash = this.itemData.source.source.content.attachments[0].hash;

      this.showBaseLoader();
      openDocument(hash, type).then(()=> {
        this.hideBaseLoader();
      });
    },
    openOwnerProfile() {
      const type = this.sourceCreator.type;
      const id = this.sourceCreator.id;

      if (type === 'USER') {
        window.open(`/user/${id}`, '_blank')
      } else if (type === 'FORUM') {
        window.open(`/forum/${id}`, '_blank')
      }
    }
  }
}
</script>

<template>
<div class="source-item">
  <div class="source-item__row">
    <span class="source-item__label">{{$t('actualProposal.publisher')}}</span>
    <base-avatar :img-hash="sourceCreator.imgHash"
                 :size="'SM'"
                 v-tooltip.top="sourceCreator.name"
                 class="source-owner-avatar"
                 @click="openOwnerProfile()"
    />
    <span class="source-item__text">{{sourceCreator.name}}</span>
  </div>
  <div class="source-item__row">
    <span class="source-item__label">{{$t('actualProposal.connectedToSource')}}</span>
  </div>
  <div class="source-item__row">
    <span class="source-item__link" @click="getDocument()">
      {{itemData.source.source.content.title}}
    </span>
  </div>
</div>
</template>

<style lang="scss" scoped>
.source-item {
  display: flex;
  flex-direction: column;
  min-height: 50px;
  margin-left: 10px;
  padding: 10px 0;
  position: relative;
  border-bottom: 1px solid #d1d1d1;
  &:before {
    content: "";
    position: absolute;
    left: -12px;
    height: 80px;
    width: 4px;
    background: #fe8f18;
    border-radius: 3px;
  }
  &__row {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }
  &__label {
    margin-right: 5px;
    font-size: 12px;
    color: #4f4f4f;
  }
  &__link {
    color: #7835a6;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
  }
  &__text {
    font-size: 12px;
    font-weight: 600;
    color: #4f4f4f;
  }
  .source-owner-avatar {
    margin-right: 5px;
    cursor: pointer;
  }
}
</style>